import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "au-brand" }
const _hoisted_3 = { class: "au-brand-sub" }
const _hoisted_4 = { class: "au-nav-section" }
const _hoisted_5 = { class: "au-nav-label" }
const _hoisted_6 = { class: "au-nav-label" }
const _hoisted_7 = { class: "au-nav-section" }
const _hoisted_8 = { class: "au-nav-label" }
const _hoisted_9 = { class: "au-nav-label" }
const _hoisted_10 = { class: "au-user" }
const _hoisted_11 = { class: "au-user-avatar" }
const _hoisted_12 = { style: {"min-width":"0"} }
const _hoisted_13 = { class: "au-user-name" }
const _hoisted_14 = { class: "au-user-role" }
const _hoisted_15 = { class: "au-user-actions" }
const _hoisted_16 = ["title", "aria-label"]
const _hoisted_17 = ["title", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ChangeOwnPasswordModal = _resolveComponent("ChangeOwnPasswordModal")!

  return (_openBlock(), _createElementBlock("nav", {
    class: "au-sidebar",
    "aria-label": _ctx.$t('nav.panel')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "au-brand-logo" }, [
        _createElementVNode("i", { class: "bi bi-shield-lock-fill" })
      ], -1)),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "au-brand-name" }, "Vissonic", -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("nav.panel")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("nav.management")), 1),
    _createVNode(_component_router_link, {
      class: "au-nav-item",
      to: { name: 'Dashboard' },
      title: _ctx.$t('nav.dashboard')
    }, {
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "au-nav-icon is-indigo" }, [
          _createElementVNode("i", { class: "bi bi-grid-1x2-fill" })
        ], -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("nav.dashboard")), 1)
      ]),
      _: 1
    }, 8, ["title"]),
    (_ctx.isSuperAdmin || _ctx.isDistributor)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "au-nav-item",
          to: { name: 'Clients' },
          title: _ctx.$t('nav.clients')
        }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "au-nav-icon is-emerald" }, [
              _createElementVNode("i", { class: "bi bi-briefcase-fill" })
            ], -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("nav.clients")), 1)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.isSuperAdmin)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("nav.administration")), 1),
          _createVNode(_component_router_link, {
            class: "au-nav-item",
            to: { name: 'Distributors' },
            title: _ctx.$t('nav.distributors')
          }, {
            default: _withCtx(() => [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "au-nav-icon is-rose" }, [
                _createElementVNode("i", { class: "bi bi-shop" })
              ], -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("nav.distributors")), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_router_link, {
            class: "au-nav-item",
            to: { name: 'Users' },
            title: _ctx.$t('nav.users')
          }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "au-nav-icon is-amber" }, [
                _createElementVNode("i", { class: "bi bi-people-fill" })
              ], -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("nav.users")), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.initials), 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.authStore.user?.fullName), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.roleName), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "au-user-logout",
          title: _ctx.$t('account.changePassword'),
          "aria-label": _ctx.$t('account.changePassword'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPasswordModal = true))
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("i", { class: "bi bi-key" }, null, -1)
        ]), 8, _hoisted_16),
        _createElementVNode("button", {
          type: "button",
          class: "au-user-logout",
          title: _ctx.$t('nav.logout'),
          "aria-label": _ctx.$t('nav.logout'),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1)
        ]), 8, _hoisted_17)
      ])
    ]),
    _createVNode(_component_ChangeOwnPasswordModal, {
      visible: _ctx.showPasswordModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPasswordModal = false))
    }, null, 8, ["visible"])
  ], 8, _hoisted_1))
}